import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import "./Dasboard.css";

const getGreeting = (date) => {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const GreetingBanner = ({
  name,
  portfolioStats,
  upcomingCount,
  unreadCount,
  onNavigate,
  onOpenNotifications,
}) => {
  const showChips = Boolean(onNavigate);
  const [now, setNow] = useState(new Date());
  const [waving, setWaving] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(timer);
  }, []);

  const handleWave = () => {
    setWaving(true);
    setTimeout(() => setWaving(false), 900);
  };

  // Status chips only for non-admins (admins already have the company-wide cards below)
  const chips = !showChips || !portfolioStats ? [] : [
    { label: "Live", value: portfolioStats.live, status: "live", tone: "green" },
    {
      label: "Onboarding",
      value: portfolioStats.onboarding,
      status: "onboarding",
      tone: "blue",
    },
    { label: "Exit", value: portfolioStats.exit, status: "exit", tone: "orange" },
  ];

  return (
    <div className="greeting-banner fade-in-up">
      <div className="greeting-main">
        <h3 className="greeting-title">
          {getGreeting(now)}, {name}!{" "}
          <span
            className={`greeting-wave ${waving ? "waving" : ""}`}
            onClick={handleWave}
            onMouseEnter={handleWave}
            role="img"
            aria-label="Waving hand"
          >
            👋
          </span>
        </h3>
        <p className="greeting-date">
          {now.toLocaleDateString(undefined, {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
          {" · "}
          {now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </p>
      </div>
      {showChips && (
      <div className="greeting-chips">
        {chips.map((chip) => (
          <Tooltip key={chip.status} title={`View ${chip.label.toLowerCase()} employees`}>
            <button
              type="button"
              className={`greeting-chip ${chip.tone}`}
              onClick={() => onNavigate(chip.status)}
            >
              <span className="greeting-chip-value">{chip.value}</span>
              <span className="greeting-chip-label">{chip.label}</span>
            </button>
          </Tooltip>
        ))}
        <Tooltip title="Employees starting soon">
          <button
            type="button"
            className="greeting-chip purple"
            onClick={() => onNavigate()}
          >
            <span className="greeting-chip-value">{upcomingCount}</span>
            <span className="greeting-chip-label">Starting soon</span>
          </button>
        </Tooltip>
        {onOpenNotifications && (
          <Tooltip title="Unread notifications">
            <button
              type="button"
              className="greeting-chip blue"
              onClick={onOpenNotifications}
            >
              <span className="greeting-chip-value">{unreadCount || 0}</span>
              <span className="greeting-chip-label">Unread</span>
            </button>
          </Tooltip>
        )}
      </div>
      )}
    </div>
  );
};

export default GreetingBanner;
